import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-f9c02e36"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "bottom-navigator-bar-root"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "IF2023", -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://summit-img.geekpark.net/if2023/home_icon.png"
}, null, -1));

const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "嘉宾日程", -1));

const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://summit-img.geekpark.net/if2023/schedule_icon.png"
}, null, -1));

const _hoisted_6 = ["src"];

const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "购票", -1));

const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://summit-img.geekpark.net/if2023/tickets_icon.png"
}, null, -1));

const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "我的", -1));

const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://summit-img.geekpark.net/if2023/mine_icon.png"
}, null, -1));

import dayjs from "dayjs";
import { ref, onBeforeMount, onMounted } from "vue";
import { getServerTime, date2ISO } from "../assets/utils/common.utils";
export default {
  __name: 'BottomNavigatorBar',
  props: {},

  setup(__props) {
    const props = __props;
    const active = ref("home");
    const tipPopSrc = ref("");
    onBeforeMount(() => {
      if (sessionStorage.getItem("tipPop")) {
        const tipPop = sessionStorage.getItem("tipPop");

        if (tipPop == "hide") {
          tipPopSrc.value = "";
        }
      } else {
        getServerTime().then(st => {
          const sTime = date2ISO(st);

          if (dayjs(sTime) < dayjs("2022-11-24T21:00:00+08:00")) {
            tipPopSrc.value = "https://summit-img.geekpark.net/if2023/tip_pop_pre_3.png";
            sessionStorage.setItem("tipPop", "hide");
          } else if (dayjs(sTime) >= dayjs("2022-11-24T21:00:00+08:00") && dayjs(sTime) < dayjs("2022-12-18T23:59:59+08:00")) {
            tipPopSrc.value = "https://summit-img.geekpark.net/if2023/tip_pop_3.png";
            sessionStorage.setItem("tipPop", "hide");
          } else {
            tipPopSrc.value = "";
          }
        }).catch(console.error);
      }
    });
    onMounted(() => {
      setTimeout(() => {
        if (tipPopSrc.value) {
          tipPopSrc.value = "";
        }
      }, 5000);
    });

    const onChange = index => {
      if (index == "buy") {
        tipPopSrc.value = "";
        sessionStorage.setItem("tipPop", "hide");
      }
    };

    return (_ctx, _cache) => {
      const _component_van_tabbar_item = _resolveComponent("van-tabbar-item");

      const _component_van_tabbar = _resolveComponent("van-tabbar");

      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_tabbar, {
        modelValue: active.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => active.value = $event),
        fixed: false,
        route: "",
        onChange: onChange
      }, {
        default: _withCtx(() => [_createVNode(_component_van_tabbar_item, {
          name: "home",
          replace: "",
          to: "/home",
          icon: "home-o"
        }, {
          icon: _withCtx(() => [_hoisted_3]),
          default: _withCtx(() => [_hoisted_2]),
          _: 1
        }), _createVNode(_component_van_tabbar_item, {
          name: "schedule",
          replace: "",
          to: "/schedule",
          icon: "search"
        }, {
          icon: _withCtx(() => [_hoisted_5]),
          default: _withCtx(() => [_hoisted_4]),
          _: 1
        }), _createVNode(_component_van_tabbar_item, {
          name: "buy",
          replace: "",
          to: "/buy",
          icon: "friends-o"
        }, {
          icon: _withCtx(() => [_hoisted_8]),
          default: _withCtx(() => [tipPopSrc.value ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "pre-ticket-tip",
            src: tipPopSrc.value,
            alt: "早鸟和第二件半价优惠提示"
          }, null, 8, _hoisted_6)) : _createCommentVNode("", true), _hoisted_7]),
          _: 1
        }), _createVNode(_component_van_tabbar_item, {
          name: "mine",
          replace: "",
          to: "/mine",
          icon: "setting-o"
        }, {
          icon: _withCtx(() => [_hoisted_10]),
          default: _withCtx(() => [_hoisted_9]),
          _: 1
        })]),
        _: 1
      }, 8, ["modelValue"])]);
    };
  }

};